import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { MATERIALS, scrollToId } from "./data";

const Card = ({ m, i }) => {
  const big = m.span.includes("row-span-2");
  const wide = m.key === "ferrous";
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
  };
  return (
    <Reveal delay={(i % 4) * 0.07} className={`${m.span} ${big ? "min-h-[420px] lg:min-h-0" : wide ? "min-h-[300px] lg:min-h-[260px]" : "min-h-[300px]"}`}>
      <button
        onMouseMove={onMove}
        onClick={() => scrollToId("contact")}
        data-testid={`material-card-${m.key}`}
        className="spotlight group relative flex h-full w-full flex-col justify-between overflow-hidden rounded-[24px] bg-navy p-6 text-left text-white sm:p-8"
      >
        <img src={m.img} alt={m.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-70 grayscale-[35%] transition-[transform,opacity,filter] duration-[1.2s] ease-out group-hover:scale-105 group-hover:opacity-90 group-hover:grayscale-0" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-navy/10" />
        <div className="relative flex items-start justify-between">
          <span className={`font-serif italic leading-none text-white/90 ${big ? "text-7xl sm:text-8xl" : "text-5xl"}`}>{m.sym}</span>
          {m.note && <span className="rounded-full bg-copper px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em]">{m.note}</span>}
        </div>
        <div className="relative">
          <h3 className={`font-display font-bold tracking-tight ${big ? "text-3xl sm:text-4xl" : "text-2xl"}`}>{m.name}</h3>
          <div className="mt-3 flex items-end justify-between gap-4">
            <p className="font-mono text-xs uppercase tracking-[0.12em] text-slate-200">{m.grades}</p>
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-white/10 backdrop-blur-md transition-[background-color,transform] duration-500 group-hover:rotate-45 group-hover:bg-copper">
              <ArrowUpRight className="h-4 w-4" />
            </span>
          </div>
        </div>
      </button>
    </Reveal>
  );
};

export const Materials = () => (
  <section id="materials" className="bg-white py-24 sm:py-32" data-testid="materials-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="mb-14 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <div>
          <Eyebrow>Materials we trade</Eyebrow>
          <Reveal>
            <h2 className="mt-6 max-w-3xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-navy sm:text-6xl">
              Non-ferrous at the core. <em className="font-serif font-normal italic text-copper">Ferrous</em> in range.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}><p className="max-w-sm text-base leading-relaxed text-slate-600">Aluminium and copper lead our book. Grades shown are indicative — tell us your exact specification.</p></Reveal>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:auto-rows-[250px] lg:grid-cols-4">
        {MATERIALS.map((m, i) => <Card key={m.key} m={m} i={i} />)}
      </div>
    </div>
  </section>
);
